<Video src="https://assets.elevenestudio.me/changelog-idc/changelog-1-19.mp4" />

Presentamos el **Sistema "What's New"**, una funcionalidad que mantiene a los usuarios informados sobre las mejoras y cambios en la plataforma.

## 🚀 Características Principales

### Modal "What's New" ✨
- **Modal automático** que aparece para nuevas versiones
- **Detección de versiones** no vistas por el usuario
- **Persistencia de estado** para evitar mostrar repetidamente
- **Diseño responsivo** y accesible

### Página de Changelog 📜
- **Vista cronológica** de todos los cambios
- **Sistema de etiquetas** para categorizar mejoras
- **Contenido enriquecido** con videos y componentes interactivos
- **Navegación intuitiva** entre versiones

